import React, { useState } from "react";
import styles from "./auth.module.css";
import { images,icons } from "assets";
import Text from "Components/shared/text";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import Button from "Components/shared/button";
import { Link, useNavigate } from "react-router-dom";
import useQueryParams from "hooks/useQueryParams";
import { decodeStr } from "utils/stringServices";
import { loginAction } from "services/authService";
import { ERROR_OCCUR, INIT_LOGIN, LOGIN_SUCCESS, useAuthDispatch, useAuthStore } from "providers/auth";
import { ErrorModal } from "Components/shared/successful/ErrorModal";

const RegisterComplete = () => {
    const navigate = useNavigate();
    const query = useQueryParams();
    const authDispatch = useAuthDispatch();
    const {error} = useAuthStore();
    const [errorModal, setErrorModal] = useState(error?.message);
    const [isLoading, setIsLoading] = useState(false);
    
    const completeHandler = async(e) => {
        e?.preventDefault();
        const obj = {}
        for(let key in query){
            
            obj[decodeStr(key.replace(/=/g,''))] = decodeStr(query[key.replace(/=/g,"")].replace(/=/g,""))
        }
        const body = {
            email: obj.email,
            password: obj.password
        }
        setIsLoading(true);
        try{
            authDispatch({
                type: INIT_LOGIN
            })
            setErrorModal(false);
            const {data:{message, data, status}, status: statusCode} = await loginAction(body);
            if(status === "Ok" || statusCode === 200){
                authDispatch({
                    type: LOGIN_SUCCESS,
                    token: data.accessToken,
                    userId: data.id,
                    profile: data.profile,
                    sessionKey: data.sessionKey,
                    todo: data.todo
                })
            navigate("/")
            }
        }
        catch(err){
            authDispatch({
                type: ERROR_OCCUR,
                error: err
            })
            setErrorModal(true)
        }
        finally{
            setIsLoading(false)
        }
        
    } 
    return (
        <div className={styles.root}>
             <div className={styles.Password}>
                <div >
                    <img src={icons.logo} alt="company logo" />
                </div>
                 <div className={`${styles.FormContainer} ${styles.Complete}` }  >
                     <div className="w-full row-start" style={{justifyContent:"center", margin:"2rem 0"}}>
                            <img src={icons.mark} alt="Mark" />
                     </div>
                    <Text tag="h1" style={{fontWeight:800, padding:"0 20px"}} variant="xxl">Account Created sucessfully</Text>
                    <Text color="secondary" variant="md" style={{padding:"0 20px"}} className="text-center">your accoount has been created succesfully. you can 
                        now send money anywhere in the world
                        </Text>
                        <FormControl fullWidth >
                            <Button loading={isLoading} fullWidth label="Continue" type="submit" onClick={completeHandler }/>
                        </FormControl>
                </div>
                <ErrorModal setErrorModal={setErrorModal} openModal={errorModal} message={error?.message} />
            </div>
            <div className={styles.WaterContainer}>
                <img src={images.watermark} alt="watermark" className={styles.Watermark}/>
            </div>
        </div>
    );
};

export default RegisterComplete;